import {
    Box,
    Card,
    Checkbox,
    Heading,
    List,
    ListItem,
    ListIcon,
    Stack
} from '@chakra-ui/react';

import { IoIosCheckmarkCircle } from "react-icons/io";
import { IoIosCloseCircle } from "react-icons/io";
import { FaArrowsAlt } from "react-icons/fa";
import { FaExpandArrowsAlt } from "react-icons/fa";

function SetupBooleanItem({testAttribute, passText, failText}) {
    return(
        <ListItem fontSize="sm">
            <ListIcon 
                as={testAttribute ? IoIosCheckmarkCircle : IoIosCloseCircle} 
                color={testAttribute ? 'green.500' : 'red.500'}
            />
            {testAttribute ? passText : failText}
        </ListItem>
    );
}

export function SetupBox({requestActive, setups, selectedSetup, hasCheck, onChange}) {
    const setupId = setups?.["setup_id"];
    const setupName = setups?.["setup_name"];
    const setupDescription = setups?.["setup_description"];    
    const setupSwappable = setups?.["setup_swappable"] === 1 ? true : false;
    const setupModdable = setups?.["setup_moddable"] === 1 ? true : false;
    const setupHasTwoPads = setups?.["setup_pad_count"] === 1 ? true : false;
    const setupPadCountStartStr = setupHasTwoPads ? "Two " : "One ";
    const setupPadCountEndStr = setupHasTwoPads ? "s" : "";
    const setupDefaultGameId = setups?.["setup_default_game_id"];
    const setupDefaultGameSwapStr = setupSwappable ? " by default" : "";
    let setupDefaultGame = setupDefaultGameId === 1 ? setupPadCountStartStr + "5-panel pad" + setupPadCountEndStr : setupPadCountStartStr + "4-panel pad" + setupPadCountEndStr;
    setupDefaultGame = setupDefaultGame + setupDefaultGameSwapStr;

    const cardBgColorDefault = selectedSetup === setupId ? "blue.700" : "whiteAlpha.300";
    const cardBgColorHover = selectedSetup === setupId ? "blue.600" : "whiteAlpha.400";

    const CheckboxDisplay = () => {
        if (hasCheck) {
            return(
                <Checkbox ml={3} mr={3} fontWeight="bold" size="lg" isChecked={selectedSetup === setupId} onChange={onChange}/>
            );
        }
        return ([]);
    }

    return (
        <Card 
            cursor={requestActive ? "not-allowed" : hasCheck ? "pointer" : "default"}
            userSelect="none"
            color="white"
            bgColor={cardBgColorHover}
            flexDirection="column"
            onClick={onChange}
            margin={2}
            padding={hasCheck ? 3 : 8}
            width="300px"
            _hover={{ bgColor: requestActive ? cardBgColorDefault : cardBgColorHover}}
        >
            <Heading size="md" ml={hasCheck ? "17px" : "0px" } textAlign="left">#{setupId}: {setupName}</Heading>
            <Stack direction="row">         
                <CheckboxDisplay/>       
                <Box flexdirection="column">
                    <Heading size="xs">{setupDescription}</Heading>
                    <List mt={3} ml={4}>
                        <ListItem fontSize="sm">
                            <ListIcon 
                                as={setupDefaultGameId === 1 ? FaExpandArrowsAlt : FaArrowsAlt}
                                color={setupDefaultGameId === 1 ? "blue.200" : "red.200"}
                            />
                            {setupDefaultGame}
                        </ListItem>    
                        <SetupBooleanItem testAttribute={setupSwappable} passText={"Pads may be swapped"} failText={"Pads may not be swapped"}/>
                        <SetupBooleanItem testAttribute={setupModdable} passText={"Pads may be modded"} failText={"Pads may not be modded"}/>                 
                    </List>
                </Box>
            </Stack>
        </Card>
    );
}